import { useState, useEffect } from 'react';

export const NETWORK_OFFLINE_MESSAGE = '当前网络离线，暂无法使用，请联网后重试。';
export const NETWORK_OFFLINE_TOAST_ID = 'network-status-offline';

/**
 * 检测浏览器网络连接状态的 Hook
 * @returns {boolean} 当前是否在线
 */
export function useNetworkStatus(): { isOnline: boolean } {
  const [isOnline, setIsOnline] = useState<boolean>(true);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    // 设置初始状态
    setIsOnline(navigator.onLine);

    // 添加事件监听
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return { isOnline };
}
